import { createApiSlice } from "@common";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { CRUD_INQUIRY, CRUD_INQUIRY_ALERT, CRUD_INQUIRY_BY_ID, CRUD_INQUIRY_BY_OWNER, DOWNLOAD_INQUIRY, UPLOAD_INQUIRY } from "@routes";
import axios from "axios";
// Define the API config array
const apiConfig = [
  {
    name: "addInquiry",
    method: "post",
    url: CRUD_INQUIRY,
    stateKey: "message",
  },
  {
    name: "getInquiry",
    method: "get",
    url: CRUD_INQUIRY,
    stateKey: "data",
  },
  {
    name: "getInquiryByOwner",
    method: "get",
    url: CRUD_INQUIRY_BY_OWNER,
    stateKey: "data",
  },
  {
    name: "updateInquiry",
    method: "put",
    url: CRUD_INQUIRY,
    stateKey: "message",
  },
  {
    name: "deleteInquiry",
    method: "delete",
    url: CRUD_INQUIRY,
    stateKey: "message",
  },
  {
    name: "inquiryDeleteAlert",
    method: "get",
    url: CRUD_INQUIRY_ALERT,
    stateKey: "inquiryAlertData",
  },
  {
    name: "getInquiryDetailsById",
    method: "get",
    url: CRUD_INQUIRY_BY_ID,
    stateKey: "details",
  },
  {
    name: "uploadInquiryFile",
    method: "post",
    url: UPLOAD_INQUIRY,
    stateKey: "message",
  },
];
export const downloadInquiryData = createAsyncThunk(
  "inquiry/downloadInquiryData",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      console.log("Downloading inquiry data with params:", data);
      await axios
        .get(DOWNLOAD_INQUIRY, {
          params: data,
          withCredentials: true,
          responseType: "blob",
        })
        .then((res) => {
          const url = globalThis.URL.createObjectURL(new Blob([res.data]));

          const link = document.createElement("a");

          link.href = url;

          link.setAttribute("download", "Inquirys.xlsx");

          document.body.appendChild(link);

          link.click();
        });
    } catch (err) {
      return rejectWithValue(err.response);
    }
  }
);
// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    data: [],
    details: [],
    inquiryAlertData: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    [downloadInquiryData.pending]: (state) => {
      state.loading = true;
    },

    [downloadInquiryData.fulfilled]: (state) => {
      state.loading = false;
    },

    [downloadInquiryData.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "inquiry",
  apiConfig,
  customReducers,
);
const inquirySlice = slice;

// Export the slice's reducer
export default inquirySlice.reducer;

// Export thunks
export const {
  addInquiry,
  getInquiry,
  getInquiryByOwner,
  updateInquiry,
  deleteInquiry,
  getInquiryDetailsById,
  uploadInquiryFile,
  inquiryDeleteAlert
} = thunks;

// Export actions
export const { rowSelect } = actions;
